import React, { ReactNode } from "react";
import CustomIconButton from "../Buttons/CustomIconButton";
import { HiOutlineX } from "react-icons/hi";

interface FullScreenModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
}

const FullScreenModal: React.FC<FullScreenModalProps> = ({
    isOpen,
    onClose,
    children,
}) => {
    if (!isOpen) return null;

    return (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white w-full h-full flex flex-col items-center justify-center p-10 relative ">
                <div className="w-full flex justify-start mb-4">
                    <CustomIconButton
                        icon={<HiOutlineX />}
                        onClick={onClose}
                        sx={{
                            color: "black",
                            backgroundColor: "#f0f0f0",
                            width: 30, // Reduce button size
                            height: 30,
                            padding: 0.5, // Adjust padding for a smaller appearance
                        }}
                    />
                </div>

                {children}
            </div>
        </div>
    );
};

export default FullScreenModal;
